import { CHILD } from "../../constants"

export const estados = ({
    REQUESTED:'Solicitud',
    Solicitud:'Programar',
    Programada: 'Iniciar ',
    Abierta:'Calibrar',
    Cerrada:'Lista para cerrar',
    Pagada:'Entragada'
})

export const estadosicon = ({
    REQUESTED:'bi-calendar2-week',
    Solicitud:'bi-calendar2-week',
    Programada: 'bi-caret-right-square ',
    Abierta:'bi-check2'
})

export const estadoEq=({
    

})
export const queryson = (orden) => ({
    conditions:{
        numeroOrden:orden,
        otType:CHILD
    },
    fields:null,
    options:{
        limit:1,
        sort:{
            visitas:-1
        }
    }
})

// Mapeo de estados a variantes de Badge de React Bootstrap
export const ESTADO_VARIANT = {
    REQUESTED: 'secondary',
    Solicitud: 'secondary',
    Programada: 'primary',
    'No Finalizada': 'warning',
    Abierta: 'info',
    Revisión: 'dark',
    Entrega: 'success',
    Pago: 'success',
    Cerrada: 'secondary',
    Cancelada: 'warning',
    Desactivada: 'danger'
}

